module.exports = __webpack_public_path__ + "img/14ce99a.jpg";